module.exports = __webpack_public_path__ + "img/promo.96db0a0d.webp";